import { render } from "./AppBreadcrumb.vue?vue&type=template&id=a1a731ba"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"
script.render = render

export default script